import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// ng-zorro-antd modules
import { SharedModule } from '../../shared/shared.module';

import { ProjectCardComponent } from './components/project-card/project-card.component';
import { ActivityTableComponent } from '../../shared/components/activity-table/activity-table.component';
import { EstimationTableComponent } from '../../shared/components/estimation-table/estimation-table.component';
import { DashboardComponent } from './dashboard.component';

@NgModule({
  declarations: [
    DashboardComponent,
    ProjectCardComponent,
    ActivityTableComponent,
  ],
  imports: [SharedModule, FormsModule],
  exports: [DashboardComponent],
})
export class DashboardModule {}
